import './PendingChangesControls.scss';
import { Dispatch, SetStateAction } from 'react';
import { MdDelete, MdOutlineAvTimer, MdSave } from 'react-icons/md';
import { Button } from '../Button';
import { Appearance, Design, Size } from '../designConstants';

interface PendingChangesControlsProps {
  hasPendingChanges: boolean;
  setShowPendingChanges?: Dispatch<SetStateAction<boolean>>;
  saveChanges: () => void;
  isSaving: boolean;
  clearAllChanges: () => void;
  disableSaveButton?: boolean;
}

export const PendingChangesControls = ({
  hasPendingChanges,
  setShowPendingChanges,
  saveChanges,
  isSaving,
  clearAllChanges,
  disableSaveButton = false
}: PendingChangesControlsProps) => (
  <div className='pending-changes-controls'>
    {setShowPendingChanges && (
      <Button
        size={Size.LG}
        design={Design.NEUTRAL}
        leadingElement={<MdOutlineAvTimer />}
        onClick={() => setShowPendingChanges(prev => !prev)}
        disabled={!hasPendingChanges}
      >
        View Pending Changes
      </Button>
    )}
    <Button
      size={Size.LG}
      appearance={Appearance.OUTLINED}
      leadingElement={<MdDelete />}
      onClick={clearAllChanges}
      disabled={!hasPendingChanges || isSaving}
    >
      Discard Changes
    </Button>
    <Button
      size={Size.LG}
      leadingElement={<MdSave />}
      onClick={saveChanges}
      disabled={!hasPendingChanges || disableSaveButton}
      loading={isSaving}
    >
      Save
    </Button>
  </div>
);
